module.exports = __webpack_public_path__ + "img/mentalidad.d8232e8f.png";